import React from 'react';
import { withTranslation, Trans } from 'react-i18next';

import { MUIModal, Flex, Image, Text, ButtonFilled, SvgIcon } from 'Components/Base';

const UpcomingExerciseModal = ({ t, onAcknowledge, ...props }) => {
  return (
    <MUIModal
      modalStyle={{
        padding: '29px 24px',
        borderRadius: '16px',
        maxWidth: '321px',
      }}
      fullWidth
      closeIcon={false}
      {...props}
    >
      {(openModal, closeModal) => {
        const handleCloseModal = () => {
          typeof onAcknowledge === 'function' && onAcknowledge();
          closeModal();
        };

        return (
          <Flex
            flexDirection="column"
            alignItems="center"
            style={{ gap: '16px', position: 'relative' }}
          >
            <SvgIcon
              icon={SvgIcon.ICON_LIST.CLOSE}
              size={24}
              style={{
                position: 'absolute',
                top: 4,
                right: 0,
                cursor: 'pointer',
              }}
              onClick={handleCloseModal}
            />

            <Image
              src={`/assets/images/upcomingExercise.svg`}
              width="85px"
              style={{ marginTop: '32px' }}
            />

            <Text textStyle="heading4" textAlign="center" fontWeight={500}>
              <Trans
                defaults={t('UPCOMING_EXERCISE_MODAL.TITLE')}
                components={[<br key="title" />]}
              />
            </Text>

            <Text textStyle="body1" textAlign="center" fontWeight={300}>
              {t('UPCOMING_EXERCISE_MODAL.SUBTITLE')}
            </Text>

            <ButtonFilled width={1} type="button" borderRadius="8px" onClick={handleCloseModal}>
              <Text textStyle="body1Medium">{t('UPCOMING_EXERCISE_MODAL.CONFIRM')}</Text>
            </ButtonFilled>
          </Flex>
        );
      }}
    </MUIModal>
  );
};

UpcomingExerciseModal.defaultProps = {
  onAcknowledge: () => {},
};

export default withTranslation('quiz')(UpcomingExerciseModal);
